import { DashboardScope, DashboardResultType } from '@api/domain/types';
import type { DropdownItem } from '@components/common/dropdown/types';

export const DASHBOARD_SCOPE_OPTIONS: { value: DashboardScope; label: string }[] = [
  { value: DashboardScope.Machine, label: 'Machine' },
  { value: DashboardScope.Customer, label: 'Customer' },
  { value: DashboardScope.Part, label: 'Part' },
  { value: DashboardScope.NcFile, label: 'NC Files' },
];

export const DASHBOARD_RESULT_TYPE_OPTIONS: DropdownItem<DashboardResultType>[] = [
  { value: DashboardResultType.PaidVersusActual, label: 'Paid - Actual' },
  { value: DashboardResultType.IdealVersusActual, label: 'Ideal - Average' },
  { value: DashboardResultType.Actual, label: 'Actual' },
];
